import { JsonObject, JsonProperty } from 'projects/core/src/public-api';
import { ResponcePage } from 'projects/core/src/lib/misc/data/responce-page';
import { ClientNotification } from './client-nfs';

@JsonObject('ClientNfsResponcePage')
export class ClientNfsResponcePage extends ResponcePage {

    @JsonProperty([ClientNotification], 'content')
    content: ClientNotification[];
}